import { render, staticRenderFns } from "./UpgradeWidget.vue?vue&type=template&id=17eec581&"
import script from "./UpgradeWidget.vue?vue&type=script&lang=ts&"
export * from "./UpgradeWidget.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports